<div class="w-full py-3 px-4">
  <!-- Header -->
  <div class="sm:flex items-center justify-between mb-4 gap-4">
    
    <!-- Left Title -->
    <div class="flex items-center gap-2">
      <svg
        class="size-6 cursor-pointer"
        [routerLink]="['/home']"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 22L6 12L16 2L17.775 3.775L9.55 12L17.775 20.225L16 22Z"
          fill="#C19725"
        />
      </svg>

      <span class="font-semibold text-sm sm:text-base lg:text-xl text-444">
        Order Management
      </span>
    </div>

    <!-- Tabs -->
    <div class="overflow-x-auto scrollbar-hide">
      <div
        class="grid grid-cols-2 min-w-[320px] border border-[#D9D9D9] rounded-md overflow-hidden"
      >
        <!-- Order Creation -->
        <a
          routerLink="order-creation"
          routerLinkActive="bg-c19725 text-white font-medium"
          [routerLinkActiveOptions]="{ exact: true }"
          class="text-center px-4 py-2 text-[#898989] text-sm lg:text-base hover:bg-[#f6f1cb] transition"
        >
          Order Creation
        </a>

        <!-- Issue Raw Material -->
        <a
          routerLink="issue-raw-material"
          routerLinkActive="bg-c19725 text-white font-medium"
          class="text-center px-4 py-2 text-[#898989] text-sm lg:text-base hover:bg-[#f6f1cb] transition border-l border-[#D9D9D9]"
        >
          Issue Raw Material
        </a>
      </div>
    </div>
  </div>

  <!-- Child Pages Render Here -->
  <router-outlet></router-outlet>
</div>
